import BreadCrumb from "Common/BreadCrumb";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useErrorHandler } from "../../hooks/useErrorHandler";
import { AppDispatch } from "../../store";
import { RootState } from "../../slices";
import { loadDashboardData, recalculateChartData } from "../../slices/dashboard/thunk";
import { getOrders } from "../../slices/orders/thunk";
import LocationBased from "./LocationBased";
import Widgets from "./Widgets";

const Dashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { executeWithErrorHandling } = useErrorHandler();
  const { isLoading, error, dataLoaded } = useSelector((state: RootState) => state.Dashboard);
  const { orders } = useSelector((state: RootState) => state.Orders);

  useEffect(() => {
    if (!dataLoaded) {
      executeWithErrorHandling(
        () => dispatch(loadDashboardData()),
        undefined,
        "Carregamento do dashboard"
      );
    }
  }, [dispatch, dataLoaded, executeWithErrorHandling]);

  useEffect(() => {
    if (dataLoaded && orders.length === 0) {
      dispatch(getOrders());
    }
  }, [dispatch, dataLoaded, orders.length]);

  useEffect(() => {
    if (dataLoaded && orders.length > 0) {
      dispatch(recalculateChartData());
    }
  }, [dispatch, dataLoaded, orders.length]);

  if (isLoading) {
    return (
      <React.Fragment>
        <BreadCrumb title="Dashboard" pageTitle="Dashboards" />
        <div className="flex items-center justify-center min-h-[200px]">
          <div className="text-center">
            <div className="w-8 h-8 mx-auto border-b-2 border-blue-600 rounded-full animate-spin"></div>
            <p className="mt-2 text-gray-600">Carregando dados...</p>
          </div>
        </div>
      </React.Fragment>
    );
  }

  // Verificar se é erro de token - se for, não exibir, pois será tratado pelo useErrorHandler
  if (error && !error.toLowerCase().includes("token")) {
    return (
      <React.Fragment>
        <BreadCrumb title="Dashboard" pageTitle="Dashboards" />
        <div className="p-4 m-4 border border-red-200 rounded-lg bg-red-50">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="w-5 h-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">Erro ao carregar dados</h3>
              <div className="mt-2 text-sm text-red-700">
                <p>{error}</p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <BreadCrumb title="Dashboard" pageTitle="Dashboards" />
      <Widgets />
      <LocationBased />
    </React.Fragment>
  );
};

export default Dashboard;
